import React, {Component, useState, useEffect} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import ApplyNowContent from '../components/ApplyNowContent'; 
import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import withRouter from '../components/withRouter';
import {api_base_url, base_url} from '../common/Constants'; 
import { Helmet } from "react-helmet"; 

class ApplyNow extends React.Component{
    constructor(props){
        super(props);

        
        this.state = {
            career : [],
            loading : 1 
        }
    }
    componentDidMount()
    {
        var data = { id : this.props.params.id} 
            axios.post(api_base_url+"career", data).then(response=>{
                this.setState({career:response.data}); 
                this.setState({loading:0});
            }); 
    }
    render()
    {  
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));

        if (this.state.loading === 1) {
        return <div>Loading...</div>;
      }
        return (
            
            <div>
                <Header/> 
                <Helmet>
                    <title>{"Careers - "+this.state.career.title+" - "+metas[0].title}</title>  
                    <meta name="description" content={this.state.career.meta_description} />
                    <meta name="keywords" content={this.state.career.meta_title} />
                    <meta property="og:image" content={base_url+'assets/img/logo.png'}  />
                    <link rel="canonical" href={base_url+'career-info/'+this.state.career.slug} />
                </Helmet>
                <PageHeader title={"Apply Now: " +this.state.career.title}  />
                <ApplyNowContent  content={JSON.parse(localStorage.getItem("content"))}  career={this.state.career}  />  
                <Footer/>
      
        
        </div>
       
        )
    }

}
export default withRouter(ApplyNow);;